import type { EventDetails } from "@/modules/events/types/eventDetailsApi"

import { useQuery } from "@tanstack/react-query"

import { getEventDetails } from "@/modules/events/api/getEventDetails"
import { getEventDetailsQueryKey } from "@/modules/events/hooks/getEventDetailsQueryKey"
import { useLocale } from "@/modules/locales/useLocale"

// this hook is used both in the event details page and in the event attendance page
// in the event attendance page route, the event UUID is used
// in the FO event details page route, the event slug/ID is used

// The endpoint handles slug, old ID or a UUID.
// example of ID  : "213921"
// example of slug: "213921-ey-business-game-ai-for-public-artificial-intelligence-as-a-lever-for-change-and-efficiency-in-public-services"
// example of UUID: "74c3fd27-a5b3-4ce1-a6e0-f2be35962ad6"

// When given the choice, it's recommended to use UUID in priority

export const useEventDetailsData = (slug: string): EventDetails | undefined => {
  const locale = useLocale()
  const hostname = typeof window !== "undefined" ? window.location.host : ""

  const { data } = useQuery({
    queryFn: () => getEventDetails({ hostname, locale, slug }),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getEventDetailsQueryKey({ slug }),
  })

  return data
}
